import { render } from "./LayoutsHistory.vue?vue&type=template&id=021aa75c&scoped=true"
import script from "./LayoutsHistory.vue?vue&type=script&lang=js"
export * from "./LayoutsHistory.vue?vue&type=script&lang=js"

import "./LayoutsHistory.vue?vue&type=style&index=0&id=021aa75c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021aa75c"]])

export default __exports__